module["exports"] = ["中国"];